<template>
  <v-card
    v-if="booking.status && selectedBooking.status"
    class="booking max-shadow"
  >
    <v-card-title class="pa-3">
      <div class="title font-weight-medium">
        {{ selectedBooking.event.title }}
      </div>
      
      <v-spacer />
      <span>{{ formatTime(selectedBooking.bookedDate) }}</span>
    </v-card-title>
    <v-card-text>
      <v-container
        grid-list-md
        class="pa-0"
      >
        <v-layout
          column
          wrap
        >
          <v-flex>
            <v-layout
              row
              wrap
            >
              <v-layout
                row
                wrap
                align-center
                justify-space-around
              >
                <div class="px-2">
                  <avatar
                    :text="bookedBy.name"
                    :size="38"
                    :src="bookedBy.photo"
                  />
                </div>
                <v-layout
                  column
                  wrap
                  class="px-2"
                >
                  <div
                    class="body-1"
                    style="color: rgba(0,0,0, 0.54)"
                  >
                    Booked By:
                  </div>
                  <div class="subheading font-weight-medium">
                    {{ bookedBy.name }}
                  </div>
                </v-layout>
              </v-layout>
              <div class="pr-4">
                <span :class="getStatusColor(selectedBooking.status)">{{ selectedBooking.status }}</span>
              </div>
            </v-layout>
          </v-flex>
          <v-flex class="py-2">
            <div class="py-2 subheading">
              <v-icon small>
                place
              </v-icon> {{ selectedBooking.facility.name }}
            </div>
            <div class="caption">
              {{ selectedBooking.event.description }}
            </div>
          </v-flex>
          <v-container
            grid-list-sm
            fluid
            class="pa-1"
          >
            <v-layout
              row
              wrap
            >
              <template v-for="(media, index) in event.media">
                <v-flex 
                  :key="index"            
                  xs12
                >
                  <v-img
                    v-if="media.type === 'image'"
                    style="border-radius: 6px"
                    :aspect-ratio="1.3"
                    :src="media.url"
                  />
                </v-flex>
              </template>
            </v-layout>
          </v-container>
          <comments
            v-if="selectedBooking.status !== 'cancelled'"
            :event-id="selectedBooking.event.id"
          />
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>
<script>
import Avatar from '@/components/common/Avatar';
import Comments from './Comments';
import * as moment from 'moment';
import _get from 'lodash/get';
import { firestore } from '@/firebase';
export default {
  components: {
    avatar: Avatar,
    comments: Comments
  },
  props: {
    booking: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      selectedBooking: {},
      event: {}
    };
  },
  computed: {
    bookedBy() {
      return _get(this.selectedBooking, 'bookedBy');
    },
    assignedTo() {
      return _get(this.selectedBooking, 'assignedTo');
    },
    eventRef() {
      const eventId = _get(this.selectedBooking, 'event.id');
      if (!eventId) return null;
      // console.log(eventId);
      return firestore.doc(`feed/${eventId}`);
    }
  },
  watch: {
    booking: {
      handler(val) {
        // if (!val || !val.bookedBy) return;
        this.selectedBooking = val;
      },
      immediate: true
    },
    eventRef: {
      handler(val) {
        if (!val) return;
        val.get().then(eventSnapshot => {
          const event = eventSnapshot.data();
          if (event) this.event = event;
        });
      }
    }
  },
  methods: {
    formatTime(timestamp) {
      const date = timestamp.toDate();
      const today = moment().startOf('day');
      return moment(date).isAfter(today)
        ? moment(date).fromNow()
        : moment(date).calendar(today, {
            lastWeek: 'D MMM [at] hh:mm A',
            sameElse: 'D MMM [at] hh:mm A'
          });
    },
    getStatusColor(status) {
      return status === 'cancelled'
        ? 'red--text subheading'
        : 'green--text subheading';
    },
    changebookingStatus() {
      const status = this.statusBtnTxt === 'close' ? 'closed' : 'reopened';
      this.selectedBookingRef
        .update({
          status: status
        })
        .then(() => {
          this.selectedBookingRef.get().then(booking => {
            this.selectedBooking.status = booking.data().status;
          });
        });
    }
  }
};
</script>
<style scoped>
.booking {
  height: calc(100vh - var(--toolbar-height)) !important;
  overflow-y: scroll;
}
</style>
